<template>
    <a-modal v-model="visible" title="编辑分类信息" :width="500" centered :confirmLoading="loading" @ok="doValidate()">
        <a-form-model ref="formRef" :model="formData">
            <a-row :gutter="10">
                <a-col :span="10">
                    <a-form-model-item label="分类名称" label-position="top" prop="name"
                        :rules="{ required: true, message: '请输入分类名称' }">
                        <a-input v-model="formData.name" placeholder="请输入分类名称"></a-input>
                    </a-form-model-item></a-col>
                <a-col :span="6">
                    <a-form-model-item label="排序" label-position="top" prop="sort"
                        :rules="{ required: true, message: '请输入排序值' }">
                        <a-input-number style="width:100%" v-model="formData.sort" placeholder="排序值"></a-input-number>
                    </a-form-model-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="状态" label-position="top" prop="state">
                        <a-radio-group v-model="formData.state" button-style="solid">
                            <a-radio-button :value="true">启用</a-radio-button>
                            <a-radio-button :value="false">停用</a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-form-model-item label="所属单位" label-position="top" prop="organId"
                :rules="{ required: true, message: '请选择所属单位' }">
                <choose-organ v-model="formData.organId"></choose-organ>
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>

<script>
import request from '@/config/request';
import utils from '@/common/utils';
import apiUtils from '@/common/apiUtil';

export default {
    data() {
        return {
            visible: false,
            loading: false,
            formData: {
                cateId: '',
                parentId: 0,
                name: '',
                sort: 0,
                state: true,
                organId: apiUtils.getDefaultOrganId()
            }
        }
    },
    methods: {
        doValidate() {
            this.$refs.formRef.validate(valid => {
                if (!valid) {
                    console.log(this.formData)
                    return;
                }
                this.loading = true;
                request.post('/platform/grade-mall/category/save', this.formData).then(ret => {
                    utils.success('操作成功！').then(() => {
                        this.visible = false;
                        this.$emit('success');
                    });
                }).finally(() => {
                    this.loading = false;
                })
            })
        },
        show(json) {
            this.formData.cateId = '';
            this.visible = true;
            this.$nextTick(() => {
                this.$refs.formRef.clearValidate();
                this.$refs.formRef.resetFields();
                if (json) {
                    this.formData = JSON.parse(JSON.stringify(json))
                }
            })
        }
    }
}
</script>

<style></style>